import { createContext, useContext } from "react";

export const pick = (lang, obj, field) => {
  if (lang === "en" && obj && obj[`${field}_en`]) return obj[`${field}_en`];
  return obj ? obj[field] : "";
};

export const STRINGS = {
  ar: {
    nav_about: "عن مايا",
    nav_courses: "الدورات",
    nav_consult: "جلسة 1:1 أونلاين",
    nav_journey: "رحلة التشافي",
    nav_testimonials: "آراء العملاء",
    nav_blog: "المدونة",
    nav_corporate: "التدريب المؤسسي",
    nav_faq: "الأسئلة الشائعة",
    clients_eyebrow: "شراكات وتعاونات",
    clients_title_a: "نخبة من",
    clients_title_b: "عملائنا",
    clients_cta: "للتعاون المؤسسي",
    blog_eyebrow: "كتابات ورؤى",
    blog_title_a: "أحدث",
    blog_title_b: "المقالات",
    blog_read: "اقرأ/اقرئي المقال",
    blog_empty: "مقالات جديدة قريباً",
    blog_all: "جميع المقالات",
    blog_back: "عودة للمدونة",
    banners_title_a: "قريباً",
    banners_title_b: "مع مايا",
    bannerWaMsg: (t) => `مرحباً مايا، أرغب بالتسجيل في «${t}»`,
    cta_start: "ابدأ الآن",
    hero_eyebrow: "THEMAYA — مساحة آمنة للتشافي الذاتي",
    hero_whatsapp: "تواصل واتساب",
    hero_alt: "مايا — مرشدة التشافي العقلي",
    about_eyebrow: "عن THEMAYA",
    about_you_want: "أنت تريد:",
    about_name: "مايا",
    about_role: "مرشدة رحلة التشافي",
    about_alt: "مايا",
    desires: [
      "أن تتعامل مع مشاعر العار والنقصان والتجمّد",
      "أن تحتضن ذاتك وتتقبلها وتحبها",
      "أن تحقق أخيراً كامل إمكانياتك",
    ],
    courses_eyebrow: "الخدمات والدورات",
    courses_title_a: "دورات تحفيزية نحو",
    courses_title_b: "عقلية جديدة",
    courses_desc: "دورات مسجلة ومصممة خصيصاً لمساعدتك على توجيه وعيك واكتشاف نفسك.",
    courses_enroll: "سجّل في الدورة",
    manifesto_eyebrow: "المنهجية",
    manifesto_title_a: "ابدأ رحلة",
    manifesto_title_b: "التشافي العقلي",
    chapters: [
      { num: "٠١", title: "الوعي", text: "تستخدم مايا تقنيات الاستجواب وطرح الأسئلة لمساعدتك في اكتشاف الإجابات بنفسك، مع تزويدك ببيئة موضوعية وآمنة لاستكشاف أي صعوبات تواجهها." },
      { num: "٠٢", title: "التقبّل", text: "تساعدك مايا على الشعور بالقوة وتوفر لك مجموعة من التعاليم لمواجهة التحديات والتغلب على العثرات بثقة." },
      { num: "٠٣", title: "التشافي", text: "في صميم كل هذا فكرة واحدة مفادها أنه يجب منحك القدرة على مساعدة نفسك بنفسك. تبدأ رحلة السلام الداخلي والسعادة باتخاذ الخطوة الأولى!" },
    ],
    testi_eyebrow: "آراء العملاء",
    testi_title_a: "قصص",
    testi_title_b: "تشافي حقيقية",
    faq_eyebrow: "الأسئلة الشائعة",
    faq_title_a: "كل ما تريد",
    faq_title_b: "معرفته",
    faqs: [
      { q: "ما هي TheMaya؟", a: "TheMaya مساحة آمنة للتشافي الذاتي، هدفها السماح لك بإلقاء الضوء على نفسك المختبئة ومساعدتك على احتضان أجزائك المتألمة، والتصالح مع جروحك والتخلّي عن كل ما لا يخدم هدفك الأسمى." },
      { q: "هل الدورات مباشرة أم مسجلة؟", a: "جميع الدورات مسجلة ومصممة خصيصاً لمساعدتك على توجيه وعيك واكتشاف نفسك، لتتمكن من المتابعة في الوقت الذي يناسبك وبالسرعة التي تريحك." },
      { q: "لمن تناسب هذه الرحلة؟", a: "لكل من يشعر أن شيئاً ما يعيقه عن تحقيق السعادة والنجاح، ويريد التعامل مع مشاعر العار والنقصان والتجمّد، واحتضان ذاته وتحقيق كامل إمكانياته." },
      { q: "كيف تتم الجلسات مع مايا؟", a: "تستخدم مايا تقنيات الاستجواب وطرح الأسئلة لمساعدتك في اكتشاف الإجابات بنفسك، مع تزويدك ببيئة موضوعية وآمنة لاستكشاف أي صعوبات تواجهها." },
      { q: "كيف أبدأ؟", a: "اضغط على زر «ابدأ الآن» واملأ نموذج التواصل، أو راسلنا مباشرة عبر واتساب، وستتواصل معك مايا لتحديد الخطوة الأولى المناسبة لك." },
    ],
    contact_eyebrow: "ابدأ الآن",
    contact_title_a: "خطوتك الأولى نحو",
    contact_title_b: "السلام الداخلي",
    contact_text: "رحلة السلام الداخلي والسعادة تبدأ باتخاذ الخطوة الأولى! مايا إلى جانبك لاتخاذها معك. املأ النموذج أو راسلنا مباشرة عبر واتساب.",
    contact_whatsapp: "تحدّث معنا عبر واتساب",
    form_name: "الاسم الكريم",
    form_name_ph: "اسمك",
    form_phone: "رقم الجوال",
    form_interest: "ما الذي يهمّك؟",
    interests: ["دورة مسجلة", "جلسة فردية", "استفسار عام", "تدريب مؤسسي / تعاون مع الشركات"],
    form_message: "رسالتك",
    form_message_ph: "حدّثنا عن ما تمر به أو ما تريد تحقيقه...",
    form_submit: "أرسل رسالتك",
    form_sending: "جارٍ الإرسال...",
    form_required: "يرجى تعبئة جميع الحقول",
    form_success: "وصلتنا رسالتك! ستتواصل معك مايا قريباً",
    form_error: "حدث خطأ أثناء الإرسال، جرّب عبر واتساب",
    footer_text: "مساحة آمنة للتشافي الذاتي",
    wa_aria: "تواصل عبر واتساب",
    consult_eyebrow: "جلسات فردية — واحد لواحد",
    consult_popular: "الأكثر طلباً",
    consult_price_tba: "السعر يُحدد عند التواصل",
    consultWaMsg: (t) => `مرحباً مايا، أرغب بحجز «${t}» من الاستشارات الخاصة أونلاين`,
    course_teaser: "مقدمة قصيرة عن الدورة",
    course_details: "تفاصيل الدورة",
    course_lessons: "درس فيديو",
    course_pdfs: "ملف PDF",
    course_close: "إغلاق",
    enrollMsg: (t) => `مرحباً مايا، أريد الالتحاق بـ«${t}»`,
  },
  en: {
    nav_about: "About Maya",
    nav_courses: "Courses",
    nav_consult: "1-on-1 Online Session",
    nav_journey: "The Journey",
    nav_testimonials: "Testimonials",
    nav_blog: "Blog",
    nav_corporate: "Corporate Training",
    nav_faq: "FAQ",
    clients_eyebrow: "PARTNERSHIPS & COLLABORATIONS",
    clients_title_a: "Selected",
    clients_title_b: "Clients",
    clients_cta: "For corporate collaboration",
    blog_eyebrow: "WRITINGS & INSIGHTS",
    blog_title_a: "Latest",
    blog_title_b: "Articles",
    blog_read: "Read article",
    blog_empty: "New articles coming soon",
    blog_all: "All articles",
    blog_back: "Back to blog",
    banners_title_a: "Coming soon",
    banners_title_b: "with Maya",
    bannerWaMsg: (t) => `Hello Maya, I would like to register for "${t}"`,
    cta_start: "Start Now",
    hero_eyebrow: "THEMAYA — A SAFE SPACE FOR SELF-HEALING",
    hero_whatsapp: "WhatsApp Us",
    hero_alt: "Maya — mental healing guide",
    about_eyebrow: "ABOUT THEMAYA",
    about_you_want: "You want to:",
    about_name: "Maya",
    about_role: "Your healing journey guide",
    about_alt: "Maya",
    desires: [
      "Deal with feelings of shame, inadequacy and numbness",
      "Embrace yourself, accept yourself and love yourself",
      "Finally achieve your full potential",
    ],
    courses_eyebrow: "SERVICES & COURSES",
    courses_title_a: "Motivational courses towards a",
    courses_title_b: "new mindset",
    courses_desc: "Recorded courses designed specifically to help you guide your awareness and discover yourself.",
    courses_enroll: "Enroll now",
    manifesto_eyebrow: "THE METHOD",
    manifesto_title_a: "Start your",
    manifesto_title_b: "mental healing journey",
    chapters: [
      { num: "01", title: "Awareness", text: "Maya uses questioning techniques to help you discover the answers yourself, while providing an objective and safe environment to explore any difficulties you face." },
      { num: "02", title: "Acceptance", text: "Maya helps you feel empowered and provides you with a set of teachings to face challenges and overcome obstacles with confidence." },
      { num: "03", title: "Healing", text: "At the heart of it all is one idea: you must be given the power to help yourself. The journey to inner peace and happiness begins with taking the first step!" },
    ],
    testi_eyebrow: "TESTIMONIALS",
    testi_title_a: "Real",
    testi_title_b: "healing stories",
    faq_eyebrow: "FAQ",
    faq_title_a: "Everything you want to",
    faq_title_b: "know",
    faqs: [
      { q: "What is TheMaya?", a: "TheMaya is a safe space for self-healing. Its goal is to let you shed light on your hidden self, help you embrace your hurting parts, reconcile with your wounds and let go of everything that no longer serves your highest purpose." },
      { q: "Are the courses live or recorded?", a: "All courses are recorded and designed specifically to help you guide your awareness and discover yourself, so you can follow at your own pace, whenever it suits you." },
      { q: "Who is this journey for?", a: "For anyone who feels something is holding them back from happiness and success, and who wants to deal with feelings of shame, inadequacy and numbness, embrace themselves and achieve their full potential." },
      { q: "How do sessions with Maya work?", a: "Maya uses questioning techniques to help you discover the answers yourself, while providing an objective and safe environment to explore any difficulties you face." },
      { q: "How do I start?", a: "Click the Start Now button and fill in the contact form, or message us directly on WhatsApp, and Maya will reach out to define the best first step for you." },
    ],
    contact_eyebrow: "START NOW",
    contact_title_a: "Your first step towards",
    contact_title_b: "inner peace",
    contact_text: "The journey to inner peace and happiness begins with the first step! Maya is by your side to take it with you. Fill in the form or message us directly on WhatsApp.",
    contact_whatsapp: "Chat with us on WhatsApp",
    form_name: "Full name",
    form_name_ph: "Your name",
    form_phone: "Phone number",
    form_interest: "What interests you?",
    interests: ["Recorded course", "Private session", "General inquiry", "Corporate training / partnership"],
    form_message: "Your message",
    form_message_ph: "Tell us what you are going through or what you want to achieve...",
    form_submit: "Send your message",
    form_sending: "Sending...",
    form_required: "Please fill in all fields",
    form_success: "Message received! Maya will contact you soon",
    form_error: "Something went wrong — please try WhatsApp",
    footer_text: "A safe space for self-healing",
    wa_aria: "Chat on WhatsApp",
    consult_eyebrow: "ONE-TO-ONE ONLINE SESSIONS",
    consult_popular: "Most popular",
    consult_price_tba: "Price on request",
    consultWaMsg: (t) => `Hello Maya, I would like to book "${t}" from the private online consultations`,
    course_teaser: "A short intro to the course",
    course_details: "Course details",
    course_lessons: "video lessons",
    course_pdfs: "PDF files",
    course_close: "Close",
    enrollMsg: (t) => `Hello Maya, I would like to enroll in "${t}"`,
  },
};

export const LangContext = createContext({ lang: "ar", setLang: () => {}, s: STRINGS.ar });
export const useLang = () => useContext(LangContext);
